import React from "react";
import { Row, Col ,MenuItem ,DropdownButton ,ButtonToolbar,Button,Checkbox } from 'react-bootstrap'
import Carousel from 'nuka-carousel';

class FeaturesProducts extends React.Component {
render() {
return (

<div class="product-filter">
               
         <div class="product-filter__menu shop-categorie">
         <div className="product-filter-name_holder">
      <span className="product-filter-name">  
      <img src={require("../../img/Product/medall.png")} /> 
      </span>
      <span className="product-filter-name">  Featured Products </span>
      </div>
            <div className="product-filter__menu shop-type">
               <Carousel wrapAround
               renderCenterLeftControls={({ previousSlide }) => (
               <button onClick={previousSlide}><i class="fa fa-angle-left"></i></button>
               )}
               renderCenterRightControls={({ nextSlide }) => (
               <button onClick={nextSlide}><i class="fa fa-angle-right"></i>
               </button>
               )}>
               <div className="newlook">
                  <img src={require("../../img/Product/shirt3.png")}/>
               </div>
               <div className="newlook">
                  <img src={require("../../img/Product/shirt3.png")}/>
               </div>
               </Carousel>   
            </div>
         </div>
         </div>

);
}
}
export default FeaturesProducts;


// WEBPACK FOOTER //
// ./src/Components/FeaturesProducts/FeaturesProducts.jsx